import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Tip } from '@model';
import { environment } from 'environments/environment';
import { SxErrorService } from 'app/services/sx-error.service';

@Injectable({
    providedIn: 'root'
  })
  export class TipService {
    constructor(private http: HttpClient, private sxErrorService: SxErrorService) {}

    getTips(): Observable<Tip[]>{
        return this.http.get<Tip[]>(`${environment.apiEndpoint}/Information/Tips`)
          .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
    }

    setAsRead(tip: Tip): Observable<Tip>{
        return this.http.post<Tip>(`${environment.apiEndpoint}/Information/Tips/Read`, tip)
          .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
    }
  }